import _ from "lodash";
import * as actions from "../actions";

/* eslint default-case: 0 */

const defaultState = () => ({ status: actions.STATUS_PENDING });

export default (state = defaultState(), { payload, type }) => {
    switch (type) {
        case "NOTIFICATIONS:FETCH-SUCCESS": {
            const notificationList = payload.data.Items.sort((a, b) => b.createDate - a.createDate);
            const newNotificationCount = _.countBy(notificationList, 'visibility')['new'] || 0;
            return { status: actions.STATUS_SUCCESS, data: notificationList, newNotificationCount };
        }
        case "NOTIFICATIONS:DELETE": {
            const notificationsList = state.data;
            return { ...state, data: _.without(notificationsList, payload) };
        }
        case "NOTIFICATIONS:CLEAR": {
            return { ...state, data: [], newNotificationCount: 0 };
        }
    }
    return state;
};
